<div class="container" [style.color]="isCurrentWeek ? '#ffffff' : '#0c0c50'" [style.background-color]="isCurrentWeek ? '#0c0c50' : '#e1d7d7'">
  <div class="week">{{ data.week }}</div>

  <div class="wrapper">
    <div class="row">
      <div class="year">{{ data.year }}</div>
      <div class="count">{{ data.count }}</div>
    </div>
    <div class="progress">
      <div class="progress-bar" [style.width.%]="progress"></div>
    </div>
  </div>
</div>
